import api from "./api";
import axios from "axios";
import { ASK_GROWTH_API_BASE_URL } from "../config/apiConfig";

const ask_growth_api = axios.create({
  baseURL: ASK_GROWTH_API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

ask_growth_api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("access_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

/**
 * Generates twinning data for a user.
 * @param {Object} payload - { company_name, role, username }
 */
export const generateTwinning = async (payload) => {
  try {
    const response = await ask_growth_api.post("/ask-growth/api/generate-twinning", payload);
    return response.data;
  } catch (error) {
    console.error("Generate Twinning Error:", error);
    throw error;
  }
};

/**
 * Updates the personal profile information using the GrowthIQ API (proxied to MnM).
 * @param {Object} personalData - { first_name, last_name, designation, business_unit, linkedin_url, user_country, company_name_for_growth_iq, company_name_for_growth_iq_demo, api_token, deviceid }
 */
export const updatePersonalProfile = async (personalData) => {
  try {
    // Ensure api_token is included in the payload (fallback to localStorage)
    const payload = {
      ...personalData,
      api_token: personalData.api_token || localStorage.getItem("access_token") || "",
    };

    // Using the centralized api instance which handles base URL and auth headers
    const response = await api.post("/users/update_user_details", payload);
    return response.data;
  } catch (error) {
    console.error("Update Personal Profile Error:", error);
    throw error;
  }
};
